import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down",
  "use": "down-usage",
  "viewBox": "0 0 26.3 15.4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26.3 15.4\" id=\"down\"><path fill=\"none\" stroke-width=\"3\" stroke-miterlimit=\"10\" d=\"M25.3 1.1L13.2 13.3 1.1 1.1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol